var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBadgeStaff = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "100%",
  viewBox: "0 0 680 680",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "g1",
  x1: 0.15,
  y1: 0,
  x2: 0.85,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F7E8A0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "20%",
  stopColor: "#DEBB50"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#B8880C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "80%",
  stopColor: "#DEBB50"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#8E6510"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g2",
  x1: 0.1,
  y1: 0,
  x2: 0.9,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F5E4A0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "35%",
  stopColor: "#C9A020"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "65%",
  stopColor: "#9A7818"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#6B4C0C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g3",
  x1: 0.2,
  y1: 0,
  x2: 0.8,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F7E8A0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "30%",
  stopColor: "#D4A825"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "70%",
  stopColor: "#A07818"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#7A5A10"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "darkD",
  x1: 0.15,
  y1: 0,
  x2: 0.85,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#484844"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "35%",
  stopColor: "#333330"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "65%",
  stopColor: "#252522"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#1C1C1A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gTxt",
  x1: 0,
  y1: 0,
  x2: 0,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F7E8A0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "30%",
  stopColor: "#E0C050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "60%",
  stopColor: "#C49A18"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#A07818"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gTxtSm",
  x1: 0,
  y1: 0,
  x2: 1,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#D4B060"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#B89830"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#9A7818"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pBord",
  x1: 0.1,
  y1: 0,
  x2: 0.9,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F5E4A0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "25%",
  stopColor: "#D4A825"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#A07818"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "75%",
  stopColor: "#D4A825"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#8E6510"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pBg",
  x1: 0,
  y1: 0,
  x2: 0,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#282826"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "40%",
  stopColor: "#161614"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#1E1E1C"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "sunTop"
}, /*#__PURE__*/React.createElement("rect", {
  x: 108,
  y: 108,
  width: 464,
  height: 187
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "sunBot"
}, /*#__PURE__*/React.createElement("rect", {
  x: 108,
  y: 385,
  width: 464,
  height: 187
})))), /*#__PURE__*/React.createElement("circle", {
  cx: 345,
  cy: 347,
  r: 308,
  fill: "#080600",
  opacity: 0.5,
  style: {
    fill: "rgb(8, 6, 0)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.5,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 306,
  fill: "url(#g1)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 306,
  fill: "none",
  stroke: "#F9EEBC",
  strokeWidth: 1.5,
  opacity: 0.25,
  style: {
    fill: "none",
    stroke: "rgb(249, 238, 188)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "1.5px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.25,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 290,
  fill: "#1C1A14",
  style: {
    fill: "rgb(28, 26, 20)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 284,
  fill: "url(#g3)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 284,
  fill: "none",
  stroke: "#F5E4A0",
  strokeWidth: 1,
  opacity: 0.2,
  style: {
    fill: "none",
    stroke: "rgb(245, 228, 160)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.2,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 270,
  fill: "#1C1A14",
  style: {
    fill: "rgb(28, 26, 20)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 264,
  fill: "url(#g2)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 250,
  fill: "none",
  stroke: "#1C1A14",
  strokeWidth: 4,
  style: {
    fill: "none",
    stroke: "rgb(28, 26, 20)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 246,
  fill: "url(#g1)",
  opacity: 0.7,
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.7,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 238,
  fill: "none",
  stroke: "#5A420C",
  strokeWidth: 2,
  style: {
    fill: "none",
    stroke: "rgb(90, 66, 12)",
    color: "rgb(255, 255, 255)",
    strokeWidth: 2,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 232,
  fill: "url(#darkD)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 232,
  fill: "none",
  stroke: "#8E6510",
  strokeWidth: 2.5,
  opacity: 0.5,
  style: {
    fill: "none",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "2.5px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.5,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 340,
  cy: 340,
  r: 228,
  fill: "none",
  stroke: "#D4A825",
  strokeWidth: 0.8,
  opacity: 0.25,
  style: {
    fill: "none",
    stroke: "rgb(212, 168, 37)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.25,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#sunTop)",
  opacity: 0.28,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.28,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}, /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 340,
  y2: 115,
  stroke: "#8E6510",
  strokeWidth: 0.7,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.7px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 325,
  y2: 117,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 355,
  y2: 117,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 312,
  y2: 119,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 368,
  y2: 119,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 298,
  y2: 123,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 382,
  y2: 123,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 284,
  y2: 128,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 396,
  y2: 128,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 270,
  y2: 134,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 410,
  y2: 134,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 256,
  y2: 142,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 424,
  y2: 142,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 242,
  y2: 152,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 438,
  y2: 152,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 228,
  y2: 163,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 452,
  y2: 163,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 216,
  y2: 177,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 464,
  y2: 177,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 204,
  y2: 192,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 476,
  y2: 192,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 192,
  y2: 210,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 488,
  y2: 210,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 180,
  y2: 230,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 500,
  y2: 230,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 170,
  y2: 250,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 510,
  y2: 250,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 162,
  y2: 270,
  stroke: "#8E6510",
  strokeWidth: 0.5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.5px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 295,
  x2: 518,
  y2: 270,
  stroke: "#8E6510",
  strokeWidth: 0.5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.5px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#sunBot)",
  opacity: 0.28,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.28,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}, /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 340,
  y2: 565,
  stroke: "#8E6510",
  strokeWidth: 0.7,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.7px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 325,
  y2: 563,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 355,
  y2: 563,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 312,
  y2: 561,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 368,
  y2: 561,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 298,
  y2: 557,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 382,
  y2: 557,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 284,
  y2: 552,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 396,
  y2: 552,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 270,
  y2: 546,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 410,
  y2: 546,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 256,
  y2: 538,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 424,
  y2: 538,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 242,
  y2: 528,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 438,
  y2: 528,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 228,
  y2: 517,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 452,
  y2: 517,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 216,
  y2: 503,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 464,
  y2: 503,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 204,
  y2: 488,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 476,
  y2: 488,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 192,
  y2: 470,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 488,
  y2: 470,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 180,
  y2: 450,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 500,
  y2: 450,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 170,
  y2: 430,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 510,
  y2: 430,
  stroke: "#8E6510",
  strokeWidth: 0.6,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.6px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 162,
  y2: 410,
  stroke: "#8E6510",
  strokeWidth: 0.5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.5px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 340,
  y1: 385,
  x2: 518,
  y2: 410,
  stroke: "#8E6510",
  strokeWidth: 0.5,
  style: {
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.5px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
})), /*#__PURE__*/React.createElement("path", {
  id: "tA",
  d: "M190,340 A150,150 0 0,1 490,340",
  fill: "none",
  style: {
    fill: "none",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("text", {
  fontFamily: "'Georgia','Times New Roman',serif",
  fontSize: 22,
  fontWeight: 700,
  fill: "url(#gTxtSm)",
  letterSpacing: 9,
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "Georgia, &quot",
    fontSize: 22,
    fontWeight: 700,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}, /*#__PURE__*/React.createElement("textPath", {
  href: "#tA",
  startOffset: "50%",
  textAnchor: "middle",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "Georgia, &quot",
    fontSize: 22,
    fontWeight: 700,
    textAnchor: "middle",
    dominantBaseline: "auto"
  }
}, "ATTRACTR")), /*#__PURE__*/React.createElement("path", {
  id: "bA",
  d: "M190,340 A150,150 0 0,0 490,340",
  fill: "none",
  style: {
    fill: "none",
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("text", {
  fontFamily: "'Georgia','Times New Roman',serif",
  fontSize: 24,
  fontWeight: 700,
  fill: "url(#gTxtSm)",
  letterSpacing: 11,
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "Georgia, &quot",
    fontSize: 24,
    fontWeight: 700,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}, /*#__PURE__*/React.createElement("textPath", {
  href: "#bA",
  startOffset: "50%",
  textAnchor: "middle",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "Georgia, &quot",
    fontSize: 24,
    fontWeight: 700,
    textAnchor: "middle",
    dominantBaseline: "auto"
  }
}, "STAFF")), /*#__PURE__*/React.createElement("rect", {
  x: 152,
  y: 296,
  width: 376,
  height: 88,
  rx: 44,
  fill: "url(#pBord)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 157,
  y: 301,
  width: 366,
  height: 78,
  rx: 39,
  fill: "none",
  stroke: "#F5E4A0",
  strokeWidth: 0.8,
  opacity: 0.2,
  style: {
    fill: "none",
    stroke: "rgb(245, 228, 160)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.2,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 161,
  y: 304,
  width: 358,
  height: 72,
  rx: 36,
  fill: "url(#pBg)",
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("rect", {
  x: 161,
  y: 304,
  width: 358,
  height: 72,
  rx: 36,
  fill: "none",
  stroke: "#8E6510",
  strokeWidth: 0.8,
  opacity: 0.2,
  style: {
    fill: "none",
    stroke: "rgb(142, 101, 16)",
    color: "rgb(255, 255, 255)",
    strokeWidth: "0.8px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 0.2,
    fontFamily: "&quot",
    fontSize: 16,
    fontWeight: 400,
    textAnchor: "start",
    dominantBaseline: "auto"
  }
}), /*#__PURE__*/React.createElement("text", {
  x: 340,
  y: 340,
  textAnchor: "middle",
  dominantBaseline: "central",
  fontFamily: "'Georgia','Times New Roman',serif",
  fontSize: 52,
  fontWeight: 700,
  fill: "url(#gTxt)",
  letterSpacing: 3,
  style: {
    stroke: "none",
    color: "rgb(255, 255, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    opacity: 1,
    fontFamily: "Georgia, &quot",
    fontSize: 52,
    fontWeight: 700,
    textAnchor: "middle",
    dominantBaseline: "central"
  }
}, "ATTRACTR"));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBadgeStaff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/badgeStaff.2cac83d6678210311f35b940232d8759.svg";